import { difference, every, isEmpty, union } from "lodash";
import AppContext from "PFApp/app_context";
import Checkbox from "PFComponents/checkbox/checkbox";
import { useContext } from "react";

type SelectAllProps = {
  className?: string;
};

export const SelectAll = ({ className }: SelectAllProps) => {
  const {
    store: {
      pages: {
        workflowPage: { tab, engagements, roles }
      }
    }
  } = useContext(AppContext);

  const {
    data: { entries },
    selectedIds,
    setSelectedIds,
    pinnedIds
  } = tab === "roles" ? roles : engagements;

  const itemsIds = union(
    entries.map(({ id }) => id),
    pinnedIds
  );

  const allSelected = !isEmpty(itemsIds) && every(itemsIds, (value) => selectedIds.includes(value));

  const handleSelectAll = () =>
    setSelectedIds(() => {
      if (allSelected) {
        return difference(selectedIds, itemsIds) || [];
      } else {
        return union(itemsIds, selectedIds);
      }
    });

  return <Checkbox className={className} checked={allSelected} handleChange={handleSelectAll} />;
};
